import module from 'nominas/nomina/module.js'
import template from './template.html'

export class NominasNominaDispersionPagosCancelarConfirmarComponent {
  admin
  idProyecto
  idNomina
  idTipoPago
  data
  omitidos
  onClose
  noCancelables
  notas
  procesando = false

  constructor (NominasNominaDispersionPagosPagados) {
    this.NominasNominaDispersionPagosPagados = NominasNominaDispersionPagosPagados
  }

  $onChanges (changes) {
    if (changes.data) {
      this.total = this.data.reduce((total, item) => total + (item.importe / item.tipo_cambio), 0)
      this.noCancelables = this.data.some((item) => !item.cancelable)
      this.chequesAsociados = this.data.reduce((total, next) => next.cheque_numero ? ++total : total, 0)
      this.timbrados = this.data.reduce((total, next) => total + (next.status_timbrado ? 1 : 0), 0)

      this.chequesAccion = undefined
    }
  }

  aceptar () {
    let data = this.data.map((item) => ({
        id: item.id,
        id_empresa: item.id_empresa,
        id_empleado: item.id_empleado,
        indice: item.indice,
        cheque_accion: item.cheque_numero ? this.chequesAccion : undefined,
        motivo: !item.cancelable ? this.notas : undefined
      }),
    )

    this.procesando = true

    this.NominasNominaDispersionPagosPagados.delete(this.idProyecto, this.idNomina, this.idTipoPago, data)
      .then(() => (this.cancelarPago(data)))
      .catch((error) => (this.error = error.data || error))
      .finally(() => (this.procesando = false))
  }

  cancelarPago (data) {
    data.forEach((item) => {
      item.status_pagado = false
      item.id_cuenta_retiro = null
      item.cuenta_retiro = null
      item.status_pagado = false
      item.fecha_pago = null
      item.cheque_numero = null
    })

    this.onClose({$event: {data: data}})
  }

  cancelar () {
    this.onClose({$event: {data: null}})
  }
}

module.component('nominasNominaDispersionPagosCancelarConfirmar', {
  controller: NominasNominaDispersionPagosCancelarConfirmarComponent,
  template,
  bindings: {
    admin: '<',
    idProyecto: '<',
    idNomina: '<',
    idTipoPago: '<',
    data: '<',
    omitidos: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/dispersion/pagos/cancelar/confirmar/component.js